const ComingSoonPage = () => import('@/views/_shared/ComingSoonPage.vue')

export default function comingSoonRoute({ path, name, comingSoonKey, resource }) {
  return {
    path,
    name,
    component: ComingSoonPage,
    meta: {
      layout: 'content',
      comingSoonKey,
      resource,
    },
  }
}
